import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Radio, Spin, Empty, Button, Divider, Popover, Flex } from "antd";
import _ from "lodash";
import { httpApi } from "api/http.api";
import { trimStr } from "utils/utils";
import CustomTagWithPlus from "components/Common/Tag/CustomTagWithPlus";

interface Job {
  id: number;
  name: string;
  // Add other properties from your API response here
}

const ProjectList: React.FC<any> = ({ onSelect, selectedProject }) => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number | null>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [cancelToken, setCancelToken] = useState<any | null>(null);

  const fetchData = async () => {
    setLoading(true);
    if (cancelToken) {
      // If there's a previous request, cancel it before making a new one
      cancelToken.cancel("New request initiated");
    }

    const newCancelToken = axios.CancelToken.source();
    setCancelToken(newCancelToken);

    try {
      const response = await httpApi.get(`/ats/job`, {
        params: { search: searchQuery, page },
        cancelToken: newCancelToken.token, // Provide the cancel token for this request
      });

      setJobs((prevJobs) =>
        _.uniqBy([...prevJobs, ...response.data.results], "name")
      );
      setTotalPages(response.data.total_pages);
    } catch (error) {
      if (axios.isCancel(error)) {
        // Request was canceled, do nothing
        window.location.href = "/403";
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRadioChange = (projectName: any) => {
    onSelect(projectName);
  };

  // Clear old results when searchQuery changes
  useEffect(() => {
    setJobs([]);
    setPage(1);
  }, [searchQuery]);

  useEffect(() => {
    fetchData();
  }, [searchQuery, page]);

  const handleScroll = () => {
    const list = document.getElementById("project-list");
    if (list && list.clientHeight + list.scrollTop === list.scrollHeight) {
      if (totalPages === null || page < totalPages) {
        setPage(page + 1);
      }
    }
  };

  useEffect(() => {
    const list = document.getElementById("project-list");
    if (list) {
      list.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (list) {
        list.removeEventListener("scroll", handleScroll);
      }
    };
  }, [page, totalPages]);

  return (
    <Flex vertical gap={20} className="mt-5">
      <Input
        type="text"
        placeholder="Start Typing Job Title"
        value={searchQuery}
        size="large"
        onChange={(e) => setSearchQuery(e.target.value)}
      />{" "}
      <div
        id="project-list"
        style={{ height: "225px", overflowY: "auto", marginTop: "10px" }}
      >
        {jobs.length > 0 ? (
          jobs.map((job: any) => (
            <p key={job.id} style={{ marginBottom: "5px", fontWeight: 500 }}>
              <Radio
                onChange={() => handleRadioChange(job)}
                checked={
                  selectedProject && selectedProject.job_id === job.job_id
                }
                className="font-normal"
              >
                <Popover
                  placement="right"
                  content={
                    <>
                      <strong>ID: </strong> {job.job_id}
                    </>
                  }
                >
                  {job.name}
                </Popover>
              </Radio>
            </p>
          ))
        ) : !loading ? (
          <Empty description="No Records Found" />
        ) : (
          ""
        )}
        {loading ? (
          <div
            style={{ margin: "auto", textAlign: "center", marginTop: "10px" }}
          >
            <Spin size="small" />
          </div>
        ) : (
          ""
        )}
      </div>
    </Flex>
  );
};

export default ProjectList;
